import React from "react"

import twitter from "../assets/images/twitter.svg"
import instagram from "../assets/images/instagram.svg"
import facebook from "../assets/images/facebook.svg"
import GradiLink from "./gradi-link"

const SocialIcon = ({ url, label = false, large = false }) => {
  const idFor = url => {
    const possible = url.split("/").slice(-1)[0]
    if (possible !== "") {
      return possible
    }
    return url.split("/").slice(-2)[0]
  }

  if (url === null) {
    return null
  }
  const className = "social-icon" + (large === true ? " large" : "")
  let source = twitter
  if (url.toLowerCase().includes("facebook")) {
    source = facebook
  } else if (url.toLowerCase().includes("instagram")) {
    source = instagram
  }
  return (
    <GradiLink to={url}>
      <div className="flex gap-5">
      <img src={source} className={className} />
      {label === true ? (
        <span className="uppercase"> {idFor(url)} </span>
      ) : (
        <></>
      )}
      </div>
    </GradiLink>
  )
}

export default SocialIcon
